import { use } from 'i18next';
import { MDBAlert, MDBCheckbox, MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit';
import React, { forwardRef, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { removeRejectedNumber } from '../../../apiclients/streamsapi_bridge';
import { formattedNumber } from './AddRemoveNumbers';

const CampaignRejectedNumbers = forwardRef((props, ref) => {
    const [addRejected, setaddRejected] = useState([]);
    const [removeRejected, setremoveRejected] = useState([]);
    const [internalError, setInternalError] = useState(false);
    const [addFlag, setaddFlag] = useState(false);
    const [removeFlag, setremoveFlag] = useState(false);
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    useEffect(() => {
        if (props.savedNum && props.savedNum.length > 0) {
            const addrej = props.savedNum.filter((num) => num.status === 3);
            setaddRejected(addrej);

            const deleterej = props.savedNum.filter((num) => num.status === 4);
            setremoveRejected(deleterej);

        }

    }, [props.savedNum])

    async function removeThisNumber() {

        try {
            if (addFlag || removeFlag) {
                setInternalError(false);
                props.setIsloading(true);
                let update = {
                    reqid: 70,
                    siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                    brand_id: props.brandid,
                    campaign_id: props.campaignid

                }
                if (addFlag) {
                    update.add = addFlag;
                } if (removeFlag) {
                    update.remove = removeFlag;
                }
                let deleteGrpReponse = await removeRejectedNumber(update);
                setTimeout(() => { props.setIsloading(false) }, 1000);
                let delInfo = await deleteGrpReponse.json();

                if (delInfo.status == 'success') {
                    props.setSuccessMessage(delInfo.message);
                    props.setRerender(true);
                    props.onClose();



                } else {
                    // localStorage.setItem("f_message", delInfo.message);
                    // window.location.href = "/smslanding";
                }
                navigate("/smslanding", {
                    state: { tab: "tab2" },
                });
                window.location.reload();
            } else {
                alert("Please select the checkbox to release the numbers.");
            }
        } catch (e) {
            console.log(`Unable to process Request :Internal server Error:!`);
            setInternalError(true);
        }
    }
    return (
        <>
         {addRejected && addRejected.length > 0 && (
        <div className='mb-4'>
            <h6>Add Request Rejected Numbers</h6>
            <MDBTable bordered>
                <MDBTableHead>
                    <tr>
                        <th width="135px" scope='col'>From</th>
                        <th width="auto" scope='col'>Reason</th>
                    </tr>
                </MDBTableHead>
                <MDBTableBody>
                    {addRejected && addRejected.length > 0 && addRejected.map((phone) => (
                        <tr>
                            <td scope='row'>{formattedNumber(phone.nums)}</td>
                            <td>{phone.reason} </td>
                        </tr>
                    ))}

                </MDBTableBody>
            </MDBTable>
            <MDBCheckbox  name='flexCheckAdd'  value={addFlag} id='flexCheckDefaultAdd' label=' Select to release the numbers and add them back to the open pool.' onChange={(e) => { setaddFlag(e.target.checked); if (props.onCheckboxChange) props.onCheckboxChange(e.target.checked || removeFlag); }} />
                </div>
                )}
                {removeRejected && removeRejected.length > 0 && (
                <div>
            <h6>Delete Request Rejected Numbers</h6>
            <MDBTable bordered>
                <MDBTableHead>
                    <tr className="bg-secondary">
                        <th width="135px" scope='col'>From</th>
                        <th width="auto" scope='col'>Reason</th>
                    </tr>
                </MDBTableHead>
                <MDBTableBody>
                    {removeRejected && removeRejected.length > 0 && removeRejected.map((phone) => (
                        <tr>
                            <td scope='row'>{formattedNumber(phone.nums)}</td>
                            <td>{phone.reason}</td>
                        </tr>
                    ))}
                </MDBTableBody>
            </MDBTable>
            <MDBCheckbox name='flexCheckRemove' value={removeFlag} id='flexCheckDefaultRemove' label='Select to release the numbers and add them back to the existing campaign.' onChange={(e) => { setremoveFlag(e.target.checked); if (props.onCheckboxChange) props.onCheckboxChange(addFlag || e.target.checked); }} />
            </div>
            )}
            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => { e.preventDefault(); removeThisNumber(e); }}>
                    {t("add")}</button>
            </div>
            {internalError && (<MDBAlert
                open
                className="alert-center"
                color="danger"
                autohide
                position="bottom-right"
                delay={5000}
            >Internal Server Error</MDBAlert>)}
        </>
    )
});

export default CampaignRejectedNumbers
